import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import './assets/style/element-variables.scss' // 重写部分element组件的样式
import MetaInfo from 'vue-meta-info'
import VueI18n from 'vue-i18n';
import VueCropper from 'vue-cropper'

initElementMessage()
import 'windi.css'
import './assets/style/base.scss'
import './assets/style/theme.scss'
import './assets/style/common.scss'

import './utils/viewport'
import uploader from 'vue-simple-uploader'

import '@/icons' // icon
import api from '@/api'
import dayjs from 'dayjs'

import mavonEditor from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'
const relativeTime = require('dayjs/plugin/relativeTime')
dayjs.extend(relativeTime)
require('dayjs/locale/zh-cn')
dayjs.locale('zh-cn')



//全局修改默认配置，点击空白处不能关闭弹窗
ElementUI.Dialog.props.closeOnClickModal.default = false
// ElementUI.Dialog.props.modalAppendToBody.default = false
Vue.use(VueCropper)
Vue.use(ElementUI)
Vue.use(uploader)
Vue.use(MetaInfo)
Vue.use(VueI18n);
Vue.use(mavonEditor)
Vue.config.productionTip = false
Vue.config.devtools = true
Vue.prototype.$api = api

const i18n = new VueI18n({

  locale: 'zh-CN', // 语言标识
  messages: {
      'zh-CN': require('@/assets/common/zh-CN.js'), // 中文语言包
      'en-US': require('@/assets/common/en-US.js'), // 英文语言包
  }
});


router.beforeEach((to, from, next) => {
  if (to.meta.metaInfo) {
    store.commit('CAHNGE_META_INFO', to.meta.metaInfo)
  }
  next() // Allow the route change first
})

new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
  methods: {

  },
  mounted() {
    // this.updateMetaTags(router.currentRoute.meta);
  }
}).$mount('#app')

// 全局设置 elementUI的$message的默认显示时间
function initElementMessage() {
  const messages = ['success', 'warning', 'info', 'error']
  messages.forEach((type) => {
    ElementUI.Message[type] = (options) => {
      if (typeof options === 'string') {
        options = {
          message: options
        }
        // 默认配置
        options.duration = 1500
        // options.showClose = true;
      }
      options.type = type
      return ElementUI.Message(options)
    }
  })
}
